/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, forwardRef, Input, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

export const DATE_PICKER_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatePickerUiComponent),
  multi: true,
};

@Component({
  selector: 'mt-date-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './date-picker.ui-component.html',
  styleUrl: './date-picker.ui-component.scss',
  providers: [DATE_PICKER_CONTROL_VALUE_ACCESSOR],
})
export class DatePickerUiComponent implements ControlValueAccessor {
  @Input() name = '';
  @Input() placeholder = '';
  @Input() model = '';
  @Input() required = false;

  @Input() label = '';

  @Input() min: string | null = '';

  @Input() errorMessage: string | null = null;
  private _innerValue = '';

  public get innerValue(): string {
    return this._innerValue;
  }

  public set innerValue(newValue: string) {
    this._innerValue = newValue;
    this.onChangeCallback(newValue);
  }

  public registerOnChange(callback: (_: string) => void) {
    this.onChangeCallback = callback;
  }

  public registerOnTouched(callback: () => void) {
    this.onTouchedCallback = callback;
  }

  writeValue(value: string): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  public onBlur() {
    this.onTouchedCallback();
  }

  private onChangeCallback: (_: string) => void = () => {};

  private onTouchedCallback: () => void = () => {};
}
